import { NavLink } from "reactstrap";
import { Devices } from "../../../../styles";
import styled from "styled-components";
import { NavLink as RouterNavLink } from "react-router-dom";
import PropTypes from "prop-types";

const StyledButton = styled(NavLink)`
  background-color: #ffffff;
  &:hover,
  &:active {
    background-color: #ffffff;
    color: #0078a8;
  }
  color: #0078a8;
  font-size: 1rem;
  border-color: #0078a8;
  width: 100%;
  @media ${Devices.desktop} {
    width: auto;
  }
  border: 1px solid #0078a8;
`;

const SignInButton = ({ children, to }) => {
  return (
    <StyledButton color="default" tag={RouterNavLink} to={to}>
      {children}
    </StyledButton>
  );
};

SignInButton.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
};
export default SignInButton;
